/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent("HTMLEvents");
  event.initEvent("resize", true, true);
  event.eventType = "message";
  window.dispatchEvent(event);
}

export function handleScrollHeader(callback) {
  let timer = 0;

  let beforeScrollTop = window.pageYOffset;
  callback = callback || function () {};
  window.addEventListener(
    "scroll",
    () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        let direction = "up";
        const afterScrollTop = window.pageYOffset;
        const delta = afterScrollTop - beforeScrollTop;
        if (delta === 0) {
          return false;
        }
        direction = delta > 0 ? "down" : "up";
        callback(direction);
        beforeScrollTop = afterScrollTop;
      }, 50);
    },
    false
  );
}

export function isIE() {
  const bw = window.navigator.userAgent;
  const compare = (s) => bw.indexOf(s) >= 0;
  const ie11 = (() => "ActiveXObject" in window)();
  return compare("MSIE") || ie11;
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = "", timeout = 1500) {
  if (id === "") {
    return;
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id));
  }, timeout);
}
export function scorePassword(pass) {
  let score = 0;
  if (!pass) {
    return score;
  }
  // award every unique letter until 5 repetitions
  const letters = {};
  for (let i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5.0 / letters[pass[i]];
  }

  // bonus points for mixing it up
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass),
  };

  let variationCount = 0;
  for (var check in variations) {
    variationCount += variations[check] === true ? 1 : 0;
  }
  score += (variationCount - 1) * 10;

  return parseInt(score);
}

export function getUrlParam(name, defaultValue) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === name) {
      return pair[1] + (pair[2] ? "=" + pair[2] : "");
    }
  }
  return defaultValue === undefined ? null : defaultValue;
}

/**
 * 手机号脱敏
 * @param {*} phone
 * @returns
 */
export function maskPhone(phone) {
  if (phone != null && phone !== undefined) {
    var reg = /(\d{3})\d*(\d{4})/;
    return phone.replace(reg, "$1****$2");
  } else {
    return "";
  }
}

/**
 * 身份证脱敏
 * @param {} idcard
 * @returns
 */
export function maskIdcard(idcard) {
  if (idcard != null && idcard !== undefined) {
    var reg = /(\d{6})\d*(\d{4})/;
    return idcard.replace(reg, "$1****$2");
  } else {
    return "";
  }
}

/**
 * 邮箱脱敏
 * @param {} email
 * @returns
 */
export function maskEmail(email) {
  if (email != null && email !== undefined) {
    var reg = /(\w{2})\w+(@\w+)/;
    return email.replace(reg, "$1****$2");
  } else {
    return "";
  }
}
